import { render, staticRenderFns } from "./Ravintoloille.vue?vue&type=template&id=4d6fa3b0&scoped=true"
import script from "./Ravintoloille.vue?vue&type=script&lang=js"
export * from "./Ravintoloille.vue?vue&type=script&lang=js"
import style0 from "./Ravintoloille.vue?vue&type=style&index=0&id=4d6fa3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6fa3b0",
  null
  
)

export default component.exports